module.exports = __webpack_public_path__ + "img/app-store.1d91ce10.png";